<template>
  <div class="table-wrapper">
    <div class="table-title-wrapper" v-if="ShowPage">
      <div class="title-wrapper">{{ sourceLabel }}</div>
      <div class="action-wrapper" v-if="columnList.length > 0">
        <div class="action-btn-wrapper">
          <slot name="actionBtn"></slot>
        </div>
      </div>
    </div>

    <div
      :class="['table-content-wrapper', loadingPager ? 'flex-content' : '']"
      v-if="columnList.length > 0"
    >
      <template v-if="!ShowPage">
        <a-spin tip="加载中..." :spinning="loadingPager" class="spin-wrapper"></a-spin>
      </template>

      <vxe-table
        v-if="ShowPage"
        ref="xTable"
        size="mini"
        :row-id="rowId"
        :scroll-y="{ gt: 0 }"
        border
        resizable
        show-header-overflow
        show-overflow
        highlight-hover-row
        highlight-current-row
        stripe
        auto-resize
        height="auto"
        :seq-config="{ startIndex: (tablePage.pageNum - 1) * tablePage.pageSize }"
        :checkbox-config="{ labelField: 'name', strict: true, checkMethod: CheckboxkMethod }"
        :data="tableData"
      >
        <vxe-table-column type="seq" width="60" fixed="left"></vxe-table-column>
        <template v-if="isShowCheck">
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        </template>
        <template v-for="item in columnList">
          <vxe-table-column
            :key="item.field"
            :field="item.field"
            :title="item.title"
            :width="item.width"
            :fixed="item.fixed"
            :align="item.align"
            :formatter="item.formatter"
            :params="item.params"
          >
            <template #default="{ row }" v-if="item.custom">
              <slot :row="row" :item="item" />
            </template>
          </vxe-table-column>
        </template>
        <slot name="extra"></slot>
        <template v-slot:empty>
          <div class="ant-table-placeholder">暂无数据</div>
        </template>
      </vxe-table>
    </div>

    <div class="pagination-wrapper">
      <a-pagination
        v-if="tablePage.total"
        v-model="tablePage.pageNum"
        :page-size-options="['10', '20', '30', '40', '50', '100']"
        :total="tablePage.total"
        show-size-changer
        :page-size="tablePage.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="tablePageChange"
      >
      </a-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomGlobalTable',
  data() {
    return {
      rowId: 'id',
      currentPage: '',
      tableData: [],
      columnList: [],
      sourceLabel: '单据来源',
      loadingPager: true,
      tablePage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      CheckBoxDisabled: false, // 禁用选项
      ishSowDetail: true,
      isShowCheck: true,
      isShowAction: false,
      ShowPage: false,
      btnLoading: false,
    }
  },
  created() {},
  methods: {
    handleDelete() {
      let hasSelect = this.$refs.xTable.getCheckboxRecords()
      if (hasSelect.length === 0) {
        this.$message.warning('请先选择要删除的节点')
        return
      }
      this.$confirm({
        title: '确定是否删除选中项?',
        content: h => <div style="color:red;">(删除金蝶单据而不是日志)</div>,
        onOk: () => {
          console.log('hasSelect', hasSelect)
          let tmpArr = hasSelect.map(v => {
            return v.id
          })
          this.$emit('handleDeleteSelect', tmpArr)
        },
        onCancel: () => {
          console.log('Cancel')
        },
        class: 'test',
      })
    },
    handlePageChange() {
      console.log('handlePageChange')
    },
    onShowSizeChange(current, pageSize) {
      console.log('onShowSizeChange', pageSize, current)
      this.$emit('backPage', { pageSize: pageSize, pageNum: current })
    },
    tablePageChange(current, pageSize) {
      console.log('tablePageChange', pageSize, current)
      this.$emit('backPage', { pageSize: pageSize, pageNum: current })
    },
    handleSearch() {
      this.$emit('backPage', { pageSize: 100, pageNum: 1 })
    },
    clearSelect() {
      this.$refs.xTable
    },
    CheckboxkMethod({ row }) {
      let tmpFlag = !(row.kbillStatus === 1 || row.kbillStatus === 3)
      return tmpFlag
    },
  },
}
</script>

<style lang="less" scoped>
.table-wrapper {
  flex-grow: 1;
  height: 0px;
  box-sizing: border-box;
  margin: 10px;
  margin-bottom: 0px;
  overflow: hidden;
  // overflow-x: auto;
  // overflow-y: auto;
  display: flex;
  flex-direction: column;
  .table-title-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-wrapper {
      font-weight: bold;
      color: grey;
    }
  }
  .table-content-wrapper {
    height: 0px;
    flex-grow: 1;
    /deep/.ant-spin-nested-loading {
      height: 100%;
      display: flex;
      justify-content: center;
      /deep/.ant-spin-container {
        height: 100%;
      }
    }
    /deep/.ant-spin-dot {
      i {
        background-color: #e84242;
      }
    }

    /deep/ .ant-spin-text {
      color: #e84242;
    }
  }
  .flex-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  .action-btn-wrapper {
    margin-right: 10px;
  }
  .line-hight-color {
    cursor: pointer;
    color: #096dd9;
  }
  /deep/.ant-pagination-item-active {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(239, 56, 56, 1);
  }
  /deep/.ant-pagination-item {
    min-width: 25px;
    height: 25px;
    line-height: 25px;
  }
  /deep/.ant-pagination-prev {
    min-width: 25px;
    height: 25px;
    line-height: 25px;
  }
  /deep/.ant-pagination-next {
    min-width: 25px;
    height: 25px;
    line-height: 25px;
  }
  /deep/.ant-select-selection--single {
    height: 25px;
  }
  /deep/.ant-select-selection--single > .ant-select-selection__rendered {
    line-height: 23px;
  }
  /deep/.ant-pagination-item-active a {
    font-size: 14px;
    font-family: HelveticaNeue;
    color: rgba(239, 56, 56, 1);
    line-height: 22px;
  }
}
</style>

<style lang="less" scoped>
.ant-table-placeholder:before {
  content: url('./../../../static/img/Dataisempty.png');
  padding-right: 1.2rem;
  position: relative;
  top: 0.2rem;
  height: 500px;
  width: 300px;
}
.ant-table-placeholder {
  font-size: 1rem;
  font-weight: bold;
  color: #666363;
  border: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/CustomGlobalTable.vue